import { render, staticRenderFns } from "./IconWrong.vue?vue&type=template&id=755c4471"
import script from "./IconWrong.vue?vue&type=script&lang=js"
export * from "./IconWrong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports